/**
 * Shared role labels and RoleBadge for project UIs.
 * Use ROLE_LABELS for display names (e.g. "Project Admin" on homepage).
 * Use ROLE_LABELS_PLURAL for section headers (e.g. "Admins" in edit form).
 */

export const ROLE_LABELS = {
    admin: 'Project Admin',
    reviewer: 'Reviewer',
    annotator: 'Annotator',
};

export const ROLE_LABELS_PLURAL = {
    admin: 'Admins',
    reviewer: 'Reviewers',
    annotator: 'Annotators',
};

/**
 * @param {object} props
 * @param {string} props.role - Role key: 'admin' | 'reviewer' | 'annotator'
 * @param {'long'|'short'} [props.variant='long'] - long: ROLE_LABELS (e.g. "Project Admin"), short: ROLE_LABELS_PLURAL (e.g. "Admins")
 * @param {string} [props.className] - Applied to the span (e.g. from a CSS module)
 */
function RoleBadge({ role, variant = 'long', className = '' }) {
    const label = variant === 'short' ? ROLE_LABELS_PLURAL[role] : ROLE_LABELS[role];
    return (
        <span className={className}>
            {label || role}
        </span>
    );
}

export default RoleBadge;
